/**
 * Returns true if any of the given option codes is set to a truthy value on the
 * company_options, regardless of whether the source is still in its original
 * array form (as received from the backend) or has already been mutated into
 * the object/map form produced by App.vue's setCompanyOptions() for the
 * currently-selected company.
 *
 * @param {Array|Object|null|undefined} companyOptions
 * @param {string[]} optionCodes
 * @returns {boolean}
 */
export const hasCompanyOptionValue = (companyOptions, optionCodes) => {
  if (!companyOptions) return false;
  if (Array.isArray(companyOptions)) {
    return companyOptions.some(opt => optionCodes.includes(opt.option_code) && opt.value);
  }
  return optionCodes.some(code => companyOptions[code]?.value);
};

export const getCompanyOptionValue = (companyOptions, optionCode) => {
  if (!companyOptions) return undefined;
  if (Array.isArray(companyOptions)) {
    return companyOptions.find(opt => opt.option_code === optionCode)?.value;
  }
  return companyOptions[optionCode]?.value;
};
